import http from './http'

class EnquiryApi {
	// 获取询盘
	static getTodayEnquiry() {
		return http.httpGet('/lavrock/work/todayData')
	}

	static getEnquiryByDate(params) {
		return http.httpPost('/lavrock/work/listDailyData', params)
	}
	// 获取3S数据
	static getBattleshipCustomerCount(params) {
		return http.httpPost('/work/getBattleshipCustomerCount', params)
	}
}
export default EnquiryApi
